import { render, staticRenderFns } from "./LanguagesPage.vue?vue&type=template&id=4f1ba35e&scoped=true&"
import script from "./LanguagesPage.vue?vue&type=script&lang=js&"
export * from "./LanguagesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ba35e",
  null
  
)

export default component.exports